module.exports = __webpack_public_path__ + "static/media/SelfAwarenessOfValues.9a4b2e84.jpg";